import React from 'react';
import {
  Button,
  Collapse,
  Nav,
  Navbar,
  NavbarToggler,
  NavItem,
} from 'reactstrap';
import { Link } from 'react-router-dom';

import firebase from 'firebase';

import AppComponent from './AppComponent';
import navData from '../../nav';
import LogoImage from '../../img/logo.svg';

class Navigation extends AppComponent {
  state = {
    isNavOpen: false,
  };

  toggle() {
    this.setState({ isNavOpen: !this.state.isNavOpen });
  }

  render() {
    const { isNavOpen } = this.state;
    const isLoggedIn = !!this.app.user;

    return (
      <Navbar className="ngl-Navigation-navbar" dark expand="lg">
        <Link className="navbar-brand" to="/" alt="Nightingale">
          <img src={LogoImage} alt="Nightingale" />
        </Link>
        {
          isLoggedIn && (
            <React.Fragment>
              <NavbarToggler onClick={() => this.toggle()}><span className="navbar-toggler-icon" /></NavbarToggler>
              <Collapse isOpen={isNavOpen} navbar>
                <Nav className="ml-auto" navbar>
                  <NavItem className="d-lg-none d-md-block"><hr /></NavItem>

                  {
                    navData.navs.map(nav => (
                      <NavItem key={nav.path} className="d-lg-none d-md-block">
                        <Link className="nav-link" to={nav.path}>{nav.label}</Link>
                      </NavItem>
                    ))
                  }

                  <NavItem className="d-lg-none d-md-block"><hr /></NavItem>

                  <NavItem>
                    {
                      this.app.user
                        ? <Button color="link" className="nav-link" onClick={() => firebase.auth().signOut()}><span className="icon-log-out" /> Log out</Button>
                        : <Link className="text-white btn nav-link" to="/login"><span className="icon-log-in" /> Log in</Link>
                    }
                  </NavItem>
                </Nav>
              </Collapse>
            </React.Fragment>
          )
        }
      </Navbar>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/core/Navigation.js